// src/actions/authTypes.js

export const SET_AUTH = "SET_AUTH"
export const SET_USER = "SET_USER"
export const SET_AUTH_LOADING = "SET_AUTH_LOADING"
export const AUTH_FAIL = "AUTH_FAIL"
export const AUTH_SUCCESS = "AUTH_SUCCESS"
export const FETCH_ERROR = "FETCH_ERROR"
export const UPDATE_FAIL = "UPDATE_FAIL"
export const AUTH_RESET = "AUTH_RESET"
export const AUTH_CLEAR_ERROR = "AUTH_CLEAR_ERROR"
export const LOGOUT = "LOGOUT"
